// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/react-big-calendar/lib/css/react-big-calendar.css
// module id = 1224
// module chunks = 0